module.exports = __webpack_public_path__ + "img/图片16.1bc64b90.png";